module.exports = __webpack_public_path__ + "img/support.7f67dce8.svg";